import React from "react";
import "./style.scss";

const Loader = () => {
  return (
    <div className="pink-loader" id="pink-loader-1">
      <div className="pink-loader-spinner"></div>
    </div>
  );
};

export default Loader;
